export { default } from "./ChallengesTeacherBanner";
